import React, { FC, Fragment, ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import { StoreContext } from "../context";


const PrivateRoute:FC<{ children:ReactNode }> = ({ children }) => {
  const { user } = useContext(StoreContext)

  if(!localStorage.getItem('token') && !user){
    return (
      <Navigate replace to="/signin" />
    )
  }
 
  return (
    <Fragment>
      {children}
    </Fragment>
  )
}

export default PrivateRoute;
